import { UrlBuilder } from "@lib-shared/lib";
import { UserPermissionsRequest } from "core/models/user-permissions.request";
import BaseLegacyCefCommercialService from "core/services/cef/base-legacy.service";
import { activityLogArea } from "core/services/user-tracking-helper";
import BaseCefCommercialService from "./base.service";
import { CefVersion } from "./constants";
import { GetAgreementsResponse, UserDetailsResponse, UpdateUserDetailsRequest, UpdateUserAgreementsRequest, EncryptedCustomerResponse, RegisterUserRequest, DeleteUserRequest, RulesResponse, CustomerWithPermissionsResponse, SignUpPrimaryUserRequest } from "./permission.service.types";
import UserDetailsWrapper from "self-service/users/management/user-details-wrapper";

//Most CEF permission calls are made directly but a few are still called via the UtilityService
class LegacyPermissionService extends BaseLegacyCefCommercialService {
    businessUnit = "DStv";

    constructor() {
        super(activityLogArea.permissions);
        const basePath = "permissions";
        this.setBaseUrl(basePath);
    }

    /*
    Links new Users with the agreements.
    Takes the agreements details and registers them with permission module. 
    The user registered first is parent user and by default all permissions are provided for the primary user
    */
    // linkUser(customerNumber: number, firstName: string, lastName: string) {
    //     const path = `/${this.businessUnit}/link/${customerNumber}?firstName=${encodeURIComponent(firstName)}&lastName=${encodeURIComponent(lastName)}`;
    //     return this.createPromiseRequest(path).get<LinkUserResponse>();
    // }

    addChildUser(request: any, inviteLink?: string) {
        const params = inviteLink
            ? "?inviteLink=" + encodeURIComponent(`${inviteLink}?c_id=${this.customerNumber}`)
            : "";

        const path = `/v3/user/add${params}`;
        return this.createPromiseRequest(path).post(request);
    }

    updateUserViaUtilityService(request: any, action = null) {
        const param = action == null ? "" : `?action=${action}`;
        const path = `/v3/user/update${param}`;
        return this.createPromiseRequest(path).post(request);
    }
};

class PermissionService extends BaseCefCommercialService {
    businessUnit = "DStv";

    constructor() {
        super(activityLogArea.permissions);
        this.setBaseUrl(`CEFCommPermissionsAPI/${CefVersion}/permissions`);
    }

    getUserDetails(listAll: boolean) {
        const allList = listAll ? "true" : "false";
        const path = `?listAll=${allList}`;
        return this.createPromiseRequest(path).get<CustomerWithPermissionsResponse>();
    }

    getAgreementsForCustomer() {
        this.validateCustomerNumber();
        const path = `agreement?customerNumber=${this.customerNumber}`;
        return this.createPromiseRequest(path).get<GetAgreementsResponse>();
    }

    getUsers() {
        const path = `${this.customerNumber}/users`;
        return this.createPromiseRequest(path).get<UserDetailsResponse>();
    }

    getPermissions() {
        const path = "rules";
        return this.createPromiseRequest(path).get<RulesResponse>();
    }

    updateChildUserDetails(request: UpdateUserDetailsRequest) {
        const path = "userDetails";

        return this.createPromiseRequest(path).put(request);
    }

    updateUserDetails(request: UpdateUserDetailsRequest) {
        delete request.childCiamId;

        return this.updateChildUserDetails(request);
    }

    updateChildUserAgreements(request: UpdateUserAgreementsRequest, userDetails: UserDetailsWrapper) {
        this.userTracking.update(userDetails.dataForTracking);

        const path = "";

        //Axios is serializing array as { 0: {} }
        const payload: UpdateUserAgreementsRequest[] = [request];
        const json = JSON.stringify(payload);
        return this.createPromiseRequest(path).put(json);
    }

    updateUserAgreements(request: UpdateUserAgreementsRequest, userDetails: UserDetailsWrapper) {
        delete request.childCiamId;
        return this.updateChildUserAgreements(request, userDetails);
    }

    customerSearchAsync(searchType: string, searchValue: string) {
        const path = new UrlBuilder("agreement").appendParam(searchType, searchValue).toString();
        return this.createPromiseRequest(path).get<EncryptedCustomerResponse>();
    }

    registerPrimaryUser(request: RegisterUserRequest) {
        const path = "registerPrimaryUser";
        return this.createPromiseRequest(path).post(request);
    }

    deleteUser(request: DeleteUserRequest, userDetails: UserDetailsWrapper) {
        this.userTracking.delete(userDetails.dataForTracking);

        return this.createPromiseRequest("").delete(request);
    }

    acceptInvitation(customerNumber: string) {
        const path = `${customerNumber}/accept`;
        return this.createPromiseRequest(path).put()
    }

    addChildUser(request: UserPermissionsRequest, inviteLink?: string) {
        return new LegacyPermissionService().addChildUser(request, inviteLink);
    }

    updateUserViaUtilityService(request: UserPermissionsRequest, action = null) {
        return new LegacyPermissionService().updateUserViaUtilityService(request, action);
    }

    signUpPrimaryUser(request: SignUpPrimaryUserRequest) {
        const path = "signupPrimaryUser";
        return this.createPromiseRequest(path).post(request);
    }
}

export default PermissionService;
